/**
 * @module app.tooltip
 */
import appTooltipConditiongrade from './tooltip/conditiongrade.js';

export default angular.module('appTooltip', [
  appTooltipConditiongrade.name
]);
